export const getPageTitle = (pathname) => {
  if (pathname.startsWith("/chat/")) pathname = "/chat";
  if (pathname.includes("skillstoredetail")) pathname = "/skillstoredetail";
  if (pathname.includes("updatePrompt")) pathname = "/updateprompt";
  let title = "";
  switch (pathname) {
    case "/home":
      title = "mksai";
      break;
    case "/chat":
      title = "Chat Terminal";
      break;
    case "/myworkspace":
      title = "My Workspace";
      break;
    case "/skillstore":
      title = " Skill Library";
      break;
    case "/updateSkill":
      title = " Update Skill ";
      break;
    case "/thirdpartyaitools":
      title = "Third Party AI Tools";
      break;
    case "/thirdpartyaitoolsdetail":
      title = "Third Party AI Tools Detail";
      break;
    case "/updatethirdpartyaitools":
      title = "Update Third Party AI Tools";
      break;
    case "/promptmanagement":
      title = "Prompt Management";
      break;
    case "/helpvideos":
      title = "Help Videos";
      break;
    case "/notificationhub":
      title = "Notification Center";
      break;
    case "/skillstoredetail":
      title = "Skill Detail";
      break;
    case "/addprompt":
      title = "Add Prompt";
      break;
    case "/createskill":
      title = "Create Skill";
      break;
      // case "/createskillbot":
      // title = "Configure Bot";
      // break;
    case "/updateprompt":
      title = "Update Prompt";
      break;
    case "/feedback":
      title = "Feedback";
      break;
    case "/aboutmks":
      title = "MKS.ai";
      break;
    case "/guidance":
      title = "Guidance & Guidelines";
      break;
    case "/help":
      title = "Help";
      break;
    case "/settings":
      title = "Settings";
      break;
    case "/login":
      title = "Login";
      break;
    case "/importprompt":
      title = "Import Bulk Prompts";
      break;
    case "/importusers":
      title = "Import Bulk Users";
      break;
    case "/users":
      title = "User Onboarding";
      break;
    case "/demographics":
      title = "Demographics Dashboard";
      break;
    case "/currentrelease":
      title = "Current Release";
      break;
    case "/upcomingrelease":
      title = "Upcoming Release";
      break;
    default:
      title = "MKS App";
  }

  return title;
};

export const getScreenName = (pathname) => {
  let title = "";
  if (pathname.startsWith("/chat/")) pathname = "/chat";
  if (pathname.includes("skillstoredetail")) pathname = "/skillstoredetail";
  if (pathname.includes("updatePrompt")) pathname = "/updateprompt";
  switch (pathname) {
    case "/home":
      title = "MKS.ai";
      break;
    case "/chat":
      title = "Chat";
      break;
    case "/myworkspace":
      title = "My Workspace";
      break;
    case "/skillstore":
      title = "Skill Library";
      break;
    case "/updateSkill":
      title = " Update Skill ";
      break;
    case "/skillstoredetail":
      title = "Skill Detail";
      break;
    // case "/createskillbot":
    //   title = "Configure Bot";
    //   break;
    case "/thirdpartyaitools":
      title = "Third Party AI Tools";
      break;
    case "/thirdpartyaitoolsdetail":
      title = "Third Party AI Tools Detail";
      break;
    case "/updatethirdpartyaitools":
      title = "Update Third Party AI Tools";
      break;
    case "/promptmanagement":
      title = "Prompt Management";
      break;
    case "/helpvideos":
      title = "Help Videos";
      break;
    case "/notificationhub":
      title = "Notification Center";
      break;
    case "/skillstoredetail":
      title = "Skill Detail";
      break;
    case "/addprompt":
      title = "Add Prompt";
      break;
    case "/createskill":
      title = "Create Skill";
      break;
    case "/updateprompt":
      title = "Update Prompt";
      break;
    case "/settings":
      title = "Settings";
      break;
    case "/feedback":
      title = "Feedback";
      break;
    case "/aboutmks":
      title = "MKS.ai";
      break;
    case "/importprompt":
      title = "Import Bulk Prompts";
      break;
    case "/importusers":
      title = "Import Bulk Users";
      break;
    case "/guidance":
      title = "Guidance & Guidelines";
      break;
    case "/help":
      title = "Help";
      break;
    case "/users":
      title = "User Onboarding";
      break;
    case "/demographics":
      title = "Demographics Dashboard";
      break;
    case "/currentrelease":
      title = "Current Release";
      break;
    case "/upcomingrelease":
      title = "Upcoming Release";
      break;
    default:
      title = "MKS App";
  }

  return title;
};

export const encodeSVG = (svgString) => {
  return encodeURIComponent(
    svgString
      .trim()
      .replace(/\\r\\n\\t/g, "")
      .replace(/\\r\\n/g, "")
      .replace(/\\n/g, "")
  )
    .replace(/'/g, "%27")
    .replace(/"/g, "%22");
};

export const getInitials = (name) => {
  if (!name) return "";

  const nameParts = name.trim().split(" ");

  const firstNameInitial = nameParts[0]?.charAt(0).toUpperCase() || "";
  const lastNameInitial =
    nameParts.length > 1
      ? nameParts[nameParts.length - 1].charAt(0).toUpperCase()
      : "";

  return firstNameInitial + lastNameInitial;
};

export const capitalizeFirstLetter = (str) => {
  if (!str) return str;

  const words = str.split(" ");

  const capitalizedWords = words.map(
    (word) => word.charAt(0).toUpperCase() + word.slice(1)
  );

  return capitalizedWords.join(" ");
};

export const clearPromptMessageSession = () => {
  localStorage.removeItem("messages");
};

export const clearChatHistorySession = () => {
  localStorage.removeItem("conversationHistory");
};

export const removeCorpToken = () => {
  localStorage.removeItem(process.env.REACT_APP_MSAL_TOKEN_KEY);
  localStorage.removeItem(process.env.REACT_APP_MSAL_ACCOUNT_KEY);
};

export const hasGroupAccess = (securityGroups, groupId) => {
  let result = true;
  if (groupId !== null && groupId !== undefined && groupId !== "") {
    if (
      securityGroups === undefined ||
      securityGroups === null ||
      securityGroups.length === 0
    ) {
      return true;
    } else {
      let found = securityGroups.find((x) => x.id === groupId);
      if (found === null || found === undefined) {
        result = false;
      }
    }
  }
  return result;
};

export const extractAndRemoveFollowUps = (text) => {
  // Regular expression to match content inside << >>
  const regex = /<<([^>>]+)>>/g;

  // Extract matched strings into an array
  const followUpQuestions = [];
  const modifiedText = text.replace(regex, (match, p1) => {
    followUpQuestions.push(p1.trim()); // Store matched question without brackets
    return ""; // Remove it from the original text
  });

  return { modifiedText: modifiedText.trim(), followUpQuestions };
};

export const checkIfPageNoExists = (filePath) => {
  const match = filePath.match(/#page=(\d+)/);

  if (match) {
    return true;
  } else {
    return false;
  }
};

export const isPDF = (url) => {
  const isUrlConatinsPDF = url.toLowerCase().includes(".pdf");
  return isUrlConatinsPDF;
};

export const extractVariables = (text) => {
  const regex = /\$([a-zA-Z_][a-zA-Z0-9_]*)/g;
  const matches = new Set();
  let match;
  while ((match = regex.exec(text)) !== null) {
    matches.add(match[0]); // Extract full match including '$'
  }
  return Array.from(matches).map((key) => ({ key, Value: "" }));
};

export const sanitizeSearchResourceName = (name) => {
  // Normalize a name to satisfy Azure Cognitive Search naming rules:
  // lowercase letters, digits, dashes only; no leading/trailing dash; max 128 chars.
  let sanitized = name.toLowerCase();
  sanitized = sanitized.replace(/[^a-z0-9-]/g, "-"); // replace disallowed chars with '-'
  sanitized = sanitized.replace(/-+/g, "-");          // collapse consecutive dashes
  sanitized = sanitized.replace(/^-+|-+$/g, "");      // no leading/trailing dash

  return sanitized.slice(0, 128);
};